export default "__VITE_ASSET__BhlfSMBB__"